// Functional component representing the list of request forms
const RFDetails = () => {
  return <></>
};

export default RFDetails;
